import { ColumnActions } from '@components';
import dayjs from 'dayjs';

interface IProps {
  handleDelete: (id: string) => void;
}

export const Columns = ({ handleDelete }: IProps) => [
  {
    title: 'Description',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Start date',
    dataIndex: 'startAt',
    key: 'startAt',
    render: (startAt: number) => dayjs(startAt).format('DD/MM/YYYY HH:mm'),
  },
  {
    title: 'End date',
    dataIndex: 'endAt',
    key: 'endAt',
    render: (endAt: number) => dayjs(endAt).format('DD/MM/YYYY HH:mm'),
  },
  {
    title: 'Action',
    key: 'action',
    dataIndex: 'id',
    width: 120,
    render: (id: string) => (
      <ColumnActions
        hideEdit
        deleteModalTitle={`Are you sure you want to delete unavailability?`}
        onDeleteModalOkClick={() => handleDelete(id)}
      />
    ),
  },
];
